__turbopack_context__.v({
  "marquee": "PartnerLogoMarquee-module__ty_j8W__marquee",
  "root": "PartnerLogoMarquee-module__ty_j8W__root",
});
